var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrophoneOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 22,
    viewBox: "0 0 17 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.83899 14.0453C10.747 14.0453 12.2758 12.5321 12.2758 10.6575L12.2873 3.88194C12.2873 2.00736 10.747 0.494141 8.83899 0.494141C6.93093 0.494141 5.39069 2.00736 5.39069 3.88194V10.6575C5.39069 12.5321 6.93093 14.0453 8.83899 14.0453ZM14.931 10.6575C14.931 14.0453 12.0114 16.4168 8.83899 16.4168C5.66656 16.4168 2.747 14.0453 2.747 10.6575H0.792969C0.792969 14.5083 3.91942 17.6929 7.68955 18.2462V21.9502H9.98842V18.2462C13.7585 17.7041 16.885 14.5196 16.885 10.6575H14.931Z",
    fill: "#004BA5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophoneOn);
export default __webpack_public_path__ + "static/media/MicrophoneOn.cc7ebad3075a0f6edd9602934b9564a4.svg";
export { ForwardRef as ReactComponent };